<template>
  <div class="auth-page">
    <site-header />
    <main class="auth-page__main">
      <div class="core-container">
        <section class="auth-page__card">
          <qr-login-panel
            :redirect="redirect"
            @success="onLoginSuccess"
          />
        </section>
      </div>
    </main>
    <site-footer />
  </div>
</template>

<script>
import SiteHeader from '@/components/home/SiteHeader.vue'
import SiteFooter from '@/components/home/SiteFooter.vue'
import QrLoginPanel from '@/components/auth/QrLoginPanel.vue'

export default {
  name: 'AuthPage',
  components: {
    SiteHeader,
    SiteFooter,
    QrLoginPanel
  },
  computed: {
    redirect() {
      return this.$route.query.redirect || '/'
    }
  },
  methods: {
    onLoginSuccess(payload) {
      this.$store.dispatch('loginSuccess', {
        token: payload.token,
        user: payload.user,
        redirect: this.redirect,
        router: this.$router
      })
    }
  }
}
</script>

<style scoped>
.auth-page {
  min-height: 100vh;
  background: var(--color-bg-main);
}

.auth-page__main {
  padding: var(--space-2xl) 0 var(--space-xl);
}

.auth-page__card {
  max-width: var(--modal-width-md);
  margin: 0 auto;
  padding: var(--space-xl);
  background: var(--color-bg-page);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-panel);
}
</style>
